import { Style } from '@components/style';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import DatePicker, { Day } from '@hassanmojab/react-modern-calendar-datepicker';
import moment from 'moment';
import twLocale from '@/ui/PreorderTimeSelector/twLocale';
import './PreorderTimeSelector.scss';
import { ReactComponent as ArrowDown } from '@/assets/img/arrow_down_gray3.svg';
import { ReactComponent as ArrowDownAlert } from '@/assets/img/arrow_down_alert.svg';
import { ReactComponent as TimeClock } from '@/assets/img/time_clock.svg';
import { useIntl, FormattedMessage } from 'react-intl';

const { alertColor, gray3Color } = new Style().getUiConfig();

const style = new Style();

export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';

function PreorderTimeSelector({
  value,
  availableTimes,
  timeInfos,
  setSelectedTime,
  showWarnMsg,
}) {
  return (
    <div style={{ width: '100%', textAlign: 'right', position: 'relative' }}>
      <div
        className="d-flex align-items-center justify-content-around"
        style={{
          textAlign: 'center',
          border: `1px solid ${!showWarnMsg ? gray3Color : alertColor}`,
          height: '42px',
          borderRadius: '10px',
          fontSize: '16px',
          width: '100%',
        }}
        data-testid="timeDropDownMenu"
        data-bs-toggle="dropdown"
      >
        <TimeClock />
        <div>
          {value === undefined ? (
            <FormattedMessage id="welcome.selectedTime" />
          ) : (
            moment(value).format('HH:mm')
          )}
        </div>
        {!showWarnMsg ? <ArrowDown /> : <ArrowDownAlert />}
      </div>
      <ul
        style={{ width: '100%', border: '1px solid #8D8C8C' }}
        className="dropdown-menu time-list"
        aria-labelledby="timeDropDownMenu"
      >
        {availableTimes.map((time, i) => {
          let timeInfo;
          timeInfos.some((info) => {
            if (info.time === time) {
              timeInfo = info;
              return true;
            }
          });
          let disabled: any = timeInfo?.full ? 'disabled' : undefined;
          return (
            <li key={i} className="div-hover">
              <div
                className="d-flex align-items-center justify-content-center"
                style={
                  disabled
                    ? {
                        fontSize: '16px',
                        color: style.getUiConfig().gray2Color,
                        height: '32px',
                      }
                    : { fontSize: '16px', height: '32px' }
                }
                onClick={() => {
                  setSelectedTime(time);
                }}
              >
                {moment(time).format('HH:mm')}{' '}
                {disabled ? <FormattedMessage id="error.order.full" /> : ''}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

PreorderTimeSelector.defaultProps = {
  value: undefined,
  availableTimes: [],
  timeInfos: [],
  setSelectedTime: () => {},
  showWarnMsg: false,
};

PreorderTimeSelector.propTypes = {
  value: PropTypes.any,
  availableTimes: PropTypes.any,
  timeInfos: PropTypes.any,
  setSelectedTime: PropTypes.func,
  showWarnMsg: PropTypes.bool,
};

export default PreorderTimeSelector;
